"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EHoverState = void 0;
/**
 * @public
 * State changes of {@link IHoverableTrait}.
 * Events are emitted to entities in the order listed in the enum.
 */
var EHoverState;
(function (EHoverState) {
    EHoverState[EHoverState["Left"] = 1] = "Left";
    /**
     * Required where entities share state, otherwise a Left state would clear the hovered state.
     */
    EHoverState[EHoverState["Unchanged"] = 2] = "Unchanged";
    EHoverState[EHoverState["SegmentChange"] = 3] = "SegmentChange";
    EHoverState[EHoverState["Entered"] = 4] = "Entered";
})(EHoverState = exports.EHoverState || (exports.EHoverState = {}));
//# sourceMappingURL=i-hoverable-trait.js.map